import { render, staticRenderFns } from "./WorkOrderDetail.vue?vue&type=template&id=4b1f6a94&scoped=true"
import script from "./WorkOrderDetail.vue?vue&type=script&lang=js"
export * from "./WorkOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderDetail.vue?vue&type=style&index=0&id=4b1f6a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f6a94",
  null
  
)

export default component.exports